export default "__VITE_ASSET__CQ50PFlO__"